import { render, staticRenderFns } from "./OTableOrderPdfComp.vue?vue&type=template&id=2262084c&"
import script from "./OTableOrderPdfComp.vue?vue&type=script&lang=js&"
export * from "./OTableOrderPdfComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports